import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
// import React from "react";
import "./BillList.css"; // Linked CSS file for styling
import logo from "../assets/images/logo.png"; // Adjust the path based on the file's location
import { message, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { getPaymentData } from "../utils/paymentData";
import axios from "axios";
import Swal from "sweetalert2";
import { useCurrency } from "../contexts/ValidationContext";
import { getCurrencySymbol } from "../utils/currencyHelper";
import config from "../config";
import paymentMethodMap from "../utils/paymentMethodMap"; // Import the payment method mapping

const Receipt = forwardRef(
  ({ invoiceId, tableNumber, takeAwayTable, services, pax,paymentData }, ref) => {
    const apiBaseUrl = config.REACT_APP_API_BASE_URL;
    const apiEndUserBaseUrl = config.REACT_APP_ENDUSER_API_BASE_URL;
    const [imageLogo, setImageLogo] = useState(null);
    const [restaurantName, setRestaurantName] = useState(null);
    const [restaurantAddress, setRestaurantAddress] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentUser, setCurrentUser] = useState(null);
    const [invoiceData, setInvoiceData] = useState(null); // New: local state for invoice data
    const navigate = useNavigate();
    const {
      totalWithoutTaxes,
      discount,
      discountAmount,
      discountType,
      totalAfterDiscount,
      taxes,
      totalTaxes,
      totalWithTaxes,
      totalWithServices,
      rounding,
      roundedTotalWithServices,
      deposit,
      payableAmount,
      depositMethod,
      cashAmount,
      balance,
      method,
      transactionId,
      remarks,
      currentCashierName,
    } = paymentData || getPaymentData();

    let _id = null; // Initialize _id to null
    useEffect(()=>{
      console.log('Payment Data',paymentData);
    },[])

    const { currency } = useCurrency();
    const symbol = getCurrencySymbol(currency);

    const getSetting = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${apiBaseUrl}/api/settings/get-settings`
        );

        if (data && data.image) {
          // setImageLogo(data.image);
          setRestaurantName(data.name);
          setRestaurantAddress(data.address);
        } else {
          setImageLogo(
            "https://bucketergroup.s3.ap-southeast-1.amazonaws.com/posfolder/logo.png"
          );
          setRestaurantName("Seiwaa");
          setRestaurantAddress("72 Dunlop Street, Singapore 209400");
        }
      } catch (error) {
        // message.error("Something Went Wrong");
        Swal.fire({
          icon: "error",
          title: "Something Went Wrong",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } finally {
        setTimeout(() => setLoading(false), 1000);
      }
    };

    // Fetch invoice data when invoiceId changes
    useEffect(() => {
      if (!invoiceId) return;
      setLoading(true);
      axios
        .get(`${apiBaseUrl}/api/payments/${invoiceId}`)
        .then(({ data }) => setInvoiceData(data))
        .catch((error) => {
          setInvoiceData(null);
          Swal.fire({
            icon: "error",
            title: "Failed to fetch invoice data",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        })
        .finally(() => setLoading(false));
    }, [invoiceId]);

    useEffect(() => {
      getSetting();
      // fetchInvoiceData(invoiceId);
      console.log("currentCashierName in line 90: ", currentCashierName);
      // console.log("ORDER",orders);
    }, []);

    // Check for current logged-in user
    useEffect(() => {
      const auth = JSON.parse(localStorage.getItem("auth"));
      if (auth) {
        const { token } = auth;
        try {
          const decoded = jwtDecode(token);
          setCurrentUser(decoded.userId); // Set the current user

          // Navigate only if the user is on an invalid page
          if (window.location.pathname === "/login") {
            navigate("/"); // Redirect to the default page only if on login
          }
        } catch (err) {
          console.error("Invalid token", err);
          localStorage.removeItem("auth");
          navigate("/login"); // Redirect to login if token is invalid
        }
      } else {
        navigate("/login"); // Redirect to login if no auth is found
      }
    }, [navigate]);
    // expose the print method
    useImperativeHandle(ref, () => ({
      printReceipt: async () => {
        await sendReceiptToBackend();
      },
    }));
    if (loading) {
      return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Spin size="large" /> {/* Loader */}
        </div>
      );
    }

    // Use invoiceData for rendering
    if (!invoiceData || !invoiceData.orderDetails) {
      return <div>No order details available for receipt.</div>;
    }
    console.log(invoiceData,'inVOICEDATA');
    const orderDetails = invoiceData.orderDetails;
    _id = invoiceData._id; // Use the _id from invoiceData

    // Sort the order items
    const orderItems = orderDetails
      .flatMap((order) =>
        Array.isArray(order.order_items) ? order.order_items : []
      )
      .sort((a, b) => {
        const getSortValue = (item) => {
          const val = item.product?.discountAble;
          if (val === false) return 0;
          return 1;
        };

        return getSortValue(b) - getSortValue(a);
      });


    const sendReceiptToBackend = async () => {
      const selectedPrinterId = localStorage.getItem("selectedPrinterId");
      const payload = {
        logo: imageLogo,
        resName: restaurantName,
        address: restaurantAddress,
        tableNumber,
        invoiceId,
        cashierName: currentCashierName,
        items: consolidateItems(orderDetails),
        total: (parseFloat(totalWithoutTaxes) || 0).toFixed(2),
        discount: (parseFloat(discount) || 0).toFixed(2),
        subTotal: (parseFloat(totalAfterDiscount) || 0).toFixed(2),
        taxes: taxes,
        grandTotalBeforeRounding: (parseFloat(totalWithServices) || 0).toFixed(
          2
        ),
        roundingAmount: (parseFloat(rounding) || 0).toFixed(2),
        grandTotal: (parseFloat(roundedTotalWithServices) || 0).toFixed(2),
        paymentMethod: paymentMethodMap[method] || method,
        cashAmount:
          method === "Cash" ? (parseFloat(cashAmount) || 0).toFixed(2) : null,
        change:
          method === "Cash"
            ? Math.max(0, parseFloat(balance)).toFixed(2)
            : null,
        remarks,
        selectedPrinterId: selectedPrinterId,
        takeAwayTable,
        services,
        deposits: {
          haveDeposit: Number(deposit) > 0,
          amount: deposit,
          method: paymentMethodMap[depositMethod],
          payable: payableAmount,
        },
        transactionId,
        url: apiEndUserBaseUrl,
        _id: _id, // Pass the order ID
      };
      console.log("payload", payload);

      try {
        const response = await axios.post(
          `${apiBaseUrl}/api/printreceipt`,
          payload
        );
        if (response.data.success) {
          Swal.fire({
            title: "Success",
            text: "Receipt print successfully!",
            toast: true,
            icon: "success",
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          // throw new Error(
          //   response.data.message || "Failed to send receipt data."
          // );
          Swal.fire({
            icon: "error",
            title: response.data.message || "Failed to send receipt data",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        // console.error("Error sending receipt to backend:", error);
        // message.error("Failed to send receipt data to backend.");
        Swal.fire({
          icon: "error",
          title: "Failed to send itemized data",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    };

    // Function to consolidate items
    const consolidateItems = (orderDetails) => {
      const itemMap = new Map();
      orderDetails
        .flatMap((order) => order.order_items)
        .forEach((item) => {
          const discountAble = item.product.discountAble;
          const productName = item.product.name;
          const remarks = item.remarks || "";
          const addOns = item.product.addOns.map((addOn) => ({
            name: addOn.name,
            price: addOn.price,
          }));
          // Calculate total add-ons price
          let addOnsTotalPrice = 0;
          if (item.product.category === "Combo") {
            // For combo items: only add prices for custom options (from empty groups)
            addOnsTotalPrice = item.product.addOns.reduce((sum, addOn) => {
              const isCustomOption = addOn.isCategoryItem ? false : (addOn.id && !addOn._id);
              return isCustomOption ? sum + Number(addOn.price) : sum;
            }, 0);
          } else {
            // For regular items, add all add-on prices
            addOnsTotalPrice = addOns.reduce(
              (sum, addOn) => sum + Number(addOn.price),
              0
            );
          }

          // Generate a unique key based on product name, remarks, and sorted add-ons
          const addOnKey = addOns
            .map((addOn) => addOn.name)
            .sort()
            .join(",");
          const uniqueKey = `${productName}|${remarks}|${addOnKey}`;

          // Calculate item total including add-ons price
          const itemTotalPrice = (
            item.quantity *
            (item.product.price + addOnsTotalPrice)
          ).toFixed(2);

          if (itemMap.has(uniqueKey)) {
            // If item exists, update quantity and total
            const existingItem = itemMap.get(uniqueKey);
            existingItem.quantity += item.quantity;
            existingItem.total = (
              existingItem.quantity *
              (item.product.price + addOnsTotalPrice)
            ).toFixed(2);
          } else {
            // Otherwise, add new item
            itemMap.set(uniqueKey, {
              discountAble: discountAble,
              name: productName,
              addOns,
              quantity: item.quantity,
              total: itemTotalPrice,
              remarks: remarks,
            });
          }
        });

      return Array.from(itemMap.values());
    };

    return (
      <div className="body">
        <style>
          {`
                .receipt-container {
                    transform: scale(0.95)!important;  
                    transform-origin: top center;
                    margin: 0 !important;
                    padding: 0 !important;
                    border:none !important;
                    border-radius:0 !important;
                }

                body {
                    margin: 0;
                    padding: 0;
                    width: 80mm;
                    height: auto;
                    overflow: hidden;
                    font-family: Arial, sans-serif;
                    page-break-after: always;
                }

                .print-header {
                  display: none; /* This will hide the header */
                }
                  
                #invoice-content {
                    width: 80mm; 
                    padding: 0px;
                    font-family: Arial, sans-serif;
                    font-size: 12px;
                    line-height: 1.2;
                    color: #000;
                }

                .receipt-header {
                    text-align: center;
                    margin-bottom: 20px;
                    //font-size: 15px;
                }


                .receipt-details {
                    margin-bottom: 20px;
                    line-height: 1.5;
                    font-size: 13px;
                }

                .receipt-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-bottom: 20px;
                }

                .receipt-table th,
                .receipt-table td {
                    padding: 8px;
                    border-bottom: 1px solid #ddd;
                    font-size: 14px;
                }

                .receipt {
                    margin-top: 20px;
                }

                .receipt-row {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    font-family: Arial;
                    margin: 5px 0;
                }

                .remark-row {
                    font-size: 11px;
                    font-family: Arial;
                    margin: 5px 0;
                }

                .label {
                    flex: 3;
                    text-align: right;
                }

                .value {
                    flex: 1;
                    text-align: right;
                }

                // .separator {
                //     text-align: right;
                //     margin: 10px 0;
                //     color: #999;
                // }

                .separator {
                    text-align: right; 
                    border-top: 1px dashed #000; 
                    height: 1px; 
                    width: 60%;
                    margin: 10px 0;
                    margin-left: auto;
                    margin-right: 0; 
                    color: #999;
                }

                .receipt-row receipt-total{
                    display: flex;
                    justify-content: space-between;
                    font-family: Arial;
                    margin: 5px 0;

                }

                .receipt-footer {
                    text-align: center;
                    margin-top: 20px;
                    font-style: Arial;
                    color: #555;
                    font-size: 13px;
                    padding-top: 22px;
                }

                * {
                    box-shadow: none !important;
                    // background: none !important;
                }

                .receipt-container, .receipt-row, .receipt-table {
                    page-break-inside: avoid;
                }
            `}
        </style>
        <div className="receipt-container">
          <div className="receipt-header">
            <p>
              <strong>Receipt</strong>
            </p>
            <p>
              <strong>{restaurantName}</strong>
            </p>
            <p style={{ fontSize: "14px" }}>
              {restaurantAddress?.addressLine1 || ""}
              <br /> {restaurantAddress?.addressLine2 || ""}
              <br /> {restaurantAddress?.postalCodeCity || ""}
              <br /> {restaurantAddress?.stateCountry || ""}
            </p>
          </div>

          <div className="receipt-details" style={{ textAlign: "left" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "auto 1fr",
                columnGap: "2px",
                rowGap: "2px",
              }}
            >
              <p>
                <strong>No. Invoice:</strong>
              </p>
              <p>{invoiceId}</p>
              <p>
                <strong>Table Name: </strong>
              </p>
              <p>{orderDetails[0]?.order_tablenumber}</p>
              <p>
                <strong>Date & Time: </strong>
              </p>
              <p>{new Date(invoiceData.date).toLocaleString()}</p>
              <p>
                <strong>Cashier Name: </strong>
              </p>
              <p>{currentCashierName}</p>
            </div>
          </div>

          <table className="receipt-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Qty</th>
                <th style={{ textAlign: "right" }}>Price ({symbol})</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(
                orderItems.reduce((acc, item) => {
                  // Create a key based on product name, remark, and sorted list of add-on names
                  const addOnNames = item.product.addOns
                    .map((addOn) => addOn.name)
                    .sort()
                    .join(", ");
                  const key = `${item.product.name}-${
                    item.remarks || ""
                  }-${addOnNames}`;

                  acc[key] = acc[key] || {
                    productName: item.product.name,
                    addOns: item.product.addOns,
                    remark: item.remarks,
                    totalQuantity: 0,
                    discountAble: Boolean(item.product.discountAble !== false),
                    price: Number(item.product.price),
                    productCategory: item.product.category,
                  };

                  acc[key].totalQuantity += Number(item.quantity);

                  return acc;
                }, {})
              ).map(
                (
                  [
                    key,
                    {
                      productName,
                      remark,
                      discountAble,
                      totalQuantity,
                      price,
                      addOns,
                      productCategory,
                    },
                  ],
                  index
                ) => {
                  // Calculate the total add-ons price
                  let addOnsTotalPrice = 0;
                  if (productCategory === "Combo") {
                    // For combo items: only add prices for custom options (from empty groups)
                    addOnsTotalPrice = addOns.reduce((total, addOn) => {
                      const isCustomOption = addOn.isCategoryItem ? false : (addOn.id && !addOn._id);
                      return isCustomOption ? total + parseFloat(addOn.price) : total;
                    }, 0);
                  } else {
                    // For regular items, add all add-on prices
                    addOnsTotalPrice = addOns.reduce(
                      (total, addOn) => total + parseFloat(addOn.price),
                      0
                    );
                  }

                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td>
                          {productName} {discountAble ? "" : "*"}
                          <div style={{ paddingLeft: "20px" }}>
                            {Array.isArray(addOns) && addOns.length > 0 && (
                              <ul
                                style={{
                                  listStyleType: "none",
                                  padding: 0,
                                  margin: 0,
                                }}
                              >
                                {Object.entries(
                                  addOns.reduce((acc, addOn) => {
                                    if (!acc[addOn.group]) {
                                      acc[addOn.group] = {
                                        names: [],
                                        totalPrice: 0,
                                      };
                                    }
                                    acc[addOn.group].names.push(addOn.name);
                                    acc[addOn.group].totalPrice += parseFloat(
                                      addOn.price
                                    );
                                    return acc;
                                  }, {})
                                ).map(
                                  ([groupName, { names, totalPrice }], idx) => (
                                    <li key={idx}>
                                      - {names.join(", ")} (+&nbsp;
                                      {totalPrice.toFixed(2)})
                                    </li>
                                  )
                                )}
                              </ul>
                            )}
                            {remark && (
                              <div style={{ fontStyle: "italic" }}>
                                {" "}
                                - Remark: {remark}
                              </div>
                            )}
                          </div>
                        </td>
                        <td>{totalQuantity}</td>
                        <td style={{ textAlign: "right" }}>
                          {/* Calculate final total including add-ons */}
                          {((price + addOnsTotalPrice) * totalQuantity).toFixed(
                            2
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                }
              )}

              {(() => {
                const filteredServices = services.filter(
                  (service) =>
                    service.for_take_away === takeAwayTable &&
                    service.quantity > 0
                );
                if (filteredServices.length === 0) return null;

                return filteredServices.map((service, index) => (
                  <tr key={index}>
                    <td>{service.name} **</td>
                    <td>{service.quantity}</td>
                    <td style={{ textAlign: "right" }}>
                      {service.totalPrice.toFixed(2)}
                    </td>
                  </tr>
                ));
              })()}
            </tbody>
          </table>

          <div className="receipt">
            <div className="receipt-row">
              <span className="label">Total:</span>
              <span className="value">{totalWithoutTaxes}</span>
            </div>
            <div className="receipt-row">
              {/* <span className="label"></span>  */}
              <span className="label">Discount { discountType == '%' ? "(" + discountAmount + discountType + ")" : ""}:</span>
              <span className="value">
                {discount > 0
                  ? `- ${parseFloat(discount).toFixed(2)}`
                  : `${parseFloat(discount).toFixed(2)}`}
              </span>
            </div>
            <div className="receipt-row">
              <span className="label">Sub Total:</span>
              <span className="value">
                {parseFloat(totalAfterDiscount).toFixed(2)}
              </span>
            </div>
            {taxes &&
              taxes.length > 0 &&
              taxes
                .filter((tax) =>
                  takeAwayTable ? tax.taxValidForTakeAway : true
                )
                .map((tax, index) => (
                  <div className="receipt-row" key={index}>
                    <span className="label">
                      {tax.taxName} ({tax.taxRate}):
                    </span>
                    <span className="value">{tax.taxAmount}</span>
                  </div>
                ))}
            <div className="receipt-row">
              <span className="label">Pre-Rounding Total:</span>
              <span className="value">
                {parseFloat(totalWithServices).toFixed(2)}
              </span>
            </div>
            <div className="receipt-row">
              {/* <span className="label"></span>  */}
              <span className="label">Rounding:</span>
              <span className="value">
                {rounding < 0
                  ? `- ${Math.abs(rounding).toFixed(2)}`
                  : `${Math.abs(rounding).toFixed(2)}`}
              </span>
            </div>
            <div className="separator"></div>
            <div className="receipt-row receipt-total">
              <span className="label" style={{ fontSize: "18px" }}>
                Grand Total:
              </span>
              <span className="value" style={{ fontSize: "18px" }}>
                {parseFloat(roundedTotalWithServices).toFixed(2)}
              </span>
            </div>
            {Number(deposit) !== 0 && (
              <>
                <div className="receipt-row receipt-total">
                  <span className="label" style={{ fontSize: "18px" }}>
                    Deposit:
                  </span>
                  <span className="value" style={{ fontSize: "18px" }}>
                    {deposit}
                  </span>
                </div>
                <div className="receipt-row receipt-total">
                  <span className="label" style={{ fontSize: "18px" }}>
                    Payable Amount:
                  </span>
                  <span className="value" style={{ fontSize: "18px" }}>
                    {payableAmount}
                  </span>
                </div>
              </>
            )}
            {method === "Cash" ? (
              <>
                <div className="receipt-row receipt-total">
                  <span className="label">
                    {paymentMethodMap[method] || method}:
                  </span>
                  <span className="value">{cashAmount}</span>
                </div>
                <div className="separator"></div>
                <div className="receipt-row receipt-total">
                  <span className="label">Change:</span>
                  <span className="value">
                    {(parseFloat(balance) < 0
                      ? 0
                      : Math.round(balance * 20) / 20
                    ).toFixed(2)}
                  </span>
                </div>
                {Number(deposit) !== 0 && (
                  <div className="receipt-row receipt-total">
                    <span className="label" style={{ fontSize: "15px" }}>
                      Deposit Method:
                    </span>
                    <span className="value" style={{ fontSize: "15px" }}>
                      {paymentMethodMap[depositMethod] || depositMethod}
                    </span>
                  </div>
                )}
                <div className="receipt-row receipt-total">
                  <span className="label" style={{ fontSize: "15px" }}>
                    Payment Method:
                  </span>
                  <span className="value" style={{ fontSize: "15px" }}>
                    {paymentMethodMap[method] || method}
                  </span>
                </div>
              </>
            ) : (
              <>
                {Number(deposit) !== 0 && (
                  <div className="receipt-row receipt-total">
                    <span className="label" style={{ fontSize: "15px" }}>
                      Deposit Method:
                    </span>
                    <span className="value" style={{ fontSize: "15px" }}>
                      {paymentMethodMap[depositMethod] || depositMethod}
                    </span>
                  </div>
                )}
                <div className="receipt-row receipt-total">
                  <span className="label" style={{ fontSize: "15px" }}>
                    Payment Method:
                  </span>
                  <span className="value" style={{ fontSize: "15px" }}>
                    {paymentMethodMap[method] || method}
                  </span>
                </div>
                <div className="receipt-row receipt-total">
                  <span className="label" style={{ fontSize: "15px" }}>
                    Transaction ID:
                  </span>
                  <span className="value" style={{ fontSize: "15px" }}>
                    {transactionId}
                  </span>
                </div>
              </>
            )}
          </div>

          <div className="receipt-footer">
            <p>
              Items marked with * are <strong>not eligible</strong> for
              percentage discount.
            </p>
            <p>
              Service items marked with ** are <strong>only added</strong> at
              the Grand Total.
            </p>
            <p>Thank you! Please come again :)</p>
          </div>
        </div>
      </div>
    );
  }
);

export default Receipt;
